import documentTypes from '@common/constants/documents/documentTypes';

export const ORDER_TYPE_LEGAL = 'legal';
export const ORDER_TYPE_MARKETING = 'marketing';

export const translationsOrderTypesPath = {
  [ORDER_TYPE_LEGAL]: documentTypes.PRODUCT_TEXT_TRANSLATION_LEGAL_ORDER_HEADER,
  [ORDER_TYPE_MARKETING]: documentTypes.PRODUCT_TEXT_TRANSLATION_MARKETING_ORDER_HEADER
};

export const MODE_CREATE = 'create';
export const MODE_EDIT = 'edit';
